// extracted by mini-css-extract-plugin
export default {"bgVideoWrapper":"AdvtBgVideo_bgVideoWrapper__OJfrL"};